import { Link, useNavigate } from 'react-router-dom';
import { loginUser } from '../../service/login';
import { useState, useEffect, usecall } from 'react';
import {
    Box,
    Button,
    IconButton,
    InputAdornment,
    Paper,
    TextField,
    Typography,
    Link as MuiLink,
    Snackbar,
    Alert,
} from '@mui/material';
import { Visibility, VisibilityOff, MailOutline, LockOutlined, Language, ArrowForward } from '@mui/icons-material';
import ISOIcon from '../../assets/iso.svg';
import WFMHIcon from '../../assets/wfmh.svg';
import HIPAAIcon from '../../assets/hipa.svg';
// import echobuddyLogo from "../../assets/echobuddy.png";
import echobuddyLogo from "../../assets/newEchoLogo.png";
// import { requestForToken } from '../../firebase';

function LoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "info",
    });

    const navigate = useNavigate();

    const handleLogin = async () => {
        const sanitizedEmail = email.trim().replace(/['"]/g, '');
        const result = await loginUser(sanitizedEmail, password);
        console.log("Login API Response:", result);

        if (result.success && result.data) {
            // Extract user data from the response
            const userData = result.data.user || result.data; // Handle both response formats
            console.log("Extracted user data:", userData);

            // Store user data in localStorage
            localStorage.setItem("user", JSON.stringify(userData));
            localStorage.setItem("user_id", userData.id);
            localStorage.setItem("package_type", userData?.package_type);
            localStorage.setItem("account_type", userData?.account_type);
            localStorage.setItem("yoga_terms_conditions", userData?.yoga_terms_conditions);
            localStorage.setItem("account_id", userData?.account_id);

            // requestForToken(userData?.id);

            // Extract and store first name
            if (userData.name) {
                const firstName = userData.name.trim().split(' ')[0];
                console.log("Extracted first name:", firstName);
                localStorage.setItem("user_name", firstName);

                // Update the stored user object with just the first name
                userData.name = firstName;
                localStorage.setItem("user", JSON.stringify(userData));
            }

            const expiryTime = new Date().getTime() + 30 * 24 * 60 * 60 * 1000; // 30 days
            localStorage.setItem("userExpiry", expiryTime.toString());
            console.log("User stored in localStorage");
            setError("");

            navigate("/home");

            // In your handleLogin function, 
            // if (userData.account_type === "admin") {
            //     navigate("/admin");
            //     return;
            // }
            if (userData.yoga_terms_conditions === false) {
                // Navigate to terms page
                navigate('/yoga-terms');
            }


            // Add else here to make it mutually exclusive
            // else if (userData.account_type === "counsellor") {
            //     navigate("/dashboard");
            // } else {
            //     navigate("/home");
            // }
        } else {
            setError(result.error || "Login failed");
        }
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Enter' && email && password) {
                e.preventDefault();
                handleLogin();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [email, password, handleLogin]);

    const handleClose = (_, reason) => {
        if (reason === "clickaway") return; // Prevent closing when clicked outside
        setSnackbar((prev) => ({ ...prev, open: false }));
    };

    return (
        <Box sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
            p: 2,
            position: 'relative',
            overflow: 'hidden'
        }}>

            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none',
                    zIndex: 0,
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        width: 400,
                        height: 400,
                        borderRadius: '50%',
                        top: -100,
                        right: -100,
                        background: 'linear-gradient(135deg, #2ECC71, #1ABC9C)',
                        opacity: 0.1,
                        animation: 'float 20s infinite ease-in-out',
                        animationDelay: '0s',
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        width: 300,
                        height: 300,
                        borderRadius: '50%',
                        bottom: -50,
                        left: -50,
                        background: 'linear-gradient(135deg, #1ABC9C, #9B59B6)',
                        opacity: 0.1,
                        animation: 'float 20s infinite ease-in-out',
                        animationDelay: '-5s',
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        width: 200,
                        height: 200,
                        borderRadius: '50%',
                        top: '50%',
                        left: '10%',
                        background: 'linear-gradient(135deg, #9B59B6, #A855F7)',
                        opacity: 0.1,
                        animation: 'float 20s infinite ease-in-out',
                        animationDelay: '-10s',
                    }}
                />
            </Box>
            {/* Logo */}
            <Box sx={{
                position: 'absolute',
                top: { xs: 18, sm: 18, md: 24 },
                left: 24,
                zIndex: 1000,
                display: 'flex',
                alignItems: 'flex-start',
                gap: 0.75
            }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.75
                }}>
                    <img
                        // src={echobuddyLogo}
                        // alt="Echo"
                        src="/diginxthlt-logo.svg"
                        alt="Diginxthlt Logo"
                        style={{
                            height: 45,
                            width: 45,
                            // borderRadius: '50%',
                            objectFit: 'cover',
                            marginTop: "0.1rem"
                        }}
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start', // keeps left alignment
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '1.4rem',
                                fontWeight: 700,
                                letterSpacing: '0.5px',
                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                                display: 'inline-block',
                                lineHeight: 1.3, // important for 'y'
                                mb: 0.2,
                            }}
                        >
                            echoBuddy
                        </Typography>
                        <Typography
                            variant="caption"
                            sx={{
                                fontSize: '0.65rem',
                                fontWeight: 500,
                                letterSpacing: '0.3px',
                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                                display: 'inline-block',
                                lineHeight: 1.4,
                            }}
                        >
                            Connect. Heal. Rise.
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* Left Side Content */}
            <Box sx={{
                display: { xs: 'none', md: 'flex' },
                flexDirection: 'column',
                color: 'white',
                maxWidth: '50%',
                p: 4,
                zIndex: 1
            }}>
                <Typography
                    sx={{
                        mt: 1,
                        fontSize: 26,
                        fontWeight: 700,
                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        display: 'inline-block',
                        lineHeight: 1.3,
                    }}
                >
                    Connect. Heal. Rise.
                </Typography>
                <Typography
                    sx={{
                        mt: 2.5,
                        maxWidth: 560,
                        lineHeight: 1.7,
                        fontWeight: 500,
                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        display: 'inline-block',
                    }}
                >
                    Streamline your care journey with our AI-powered mental wellness platform.
                </Typography>
                <Box sx={{ display: 'flex', mt: 5 }}>
                    <Box sx={{ textAlign: 'center', mr: 4 }}>
                        <img
                            src={ISOIcon}
                            alt="ISO Certified"
                            style={{ height: 60, width: 70, filter: 'hue-rotate(90deg) saturate(1.2) brightness(1.1)' }}
                        />
                        <Typography sx={{ mt: 1, fontSize: 12, fontWeight: 500, opacity: 0.8, color: '#777', }}>
                            ISO 27001<br />Certified
                        </Typography>
                    </Box>
                    <Box sx={{ textAlign: 'center', mr: 2 }}>
                        <img src={WFMHIcon} alt="WFMH Member" style={{ height: 60 }} />
                        <Typography sx={{ mt: 1, fontSize: 12, fontWeight: 500, opacity: 0.8, color: '#777', }}>
                            WFMH<br />Member
                        </Typography>
                    </Box>
                    <Box sx={{ textAlign: 'center', }}>
                        <img
                            src={HIPAAIcon}
                            alt="HIPAA Compliant"
                            style={{ height: 50, filter: 'hue-rotate(90deg) saturate(1.2) brightness(1.1)' }}
                        />
                        <Typography sx={{ mt: 1, fontSize: 12, fontWeight: 500, opacity: 0.8, color: '#777', }}>
                            HIPAA<br />Compliant
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* Login Form */}
            <Paper
                elevation={24}
                sx={{
                    width: '100%',
                    maxWidth: 520,
                    borderRadius: 4,
                    px: { xs: 3, md: 4 },
                    py: { xs: 3, md: 4 },
                    bgcolor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(0,0,0,0.05)',
                    boxShadow: '0 24px 40px rgba(0, 0, 0, 0.12)',
                    zIndex: 1,
                    margin: { xs: '0 16px', md: '0 32px' }
                }}
            >
                <Box
                    component="form"
                    sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}

                >
                    <Box sx={{ textAlign: 'center', mb: 2 }}>
                        <Typography
                            sx={{
                                fontSize: { xs: 26, md: 30 },
                                fontWeight: 800,
                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                            }}
                        >
                            Welcome Back
                        </Typography>
                        <Typography sx={{ color: '#64748B', fontSize: 14, mb: 1 }}>
                            Sign in to your <strong>echoBuddy</strong> account
                        </Typography>
                    </Box>

                    <TextField
                        label="Email *"
                        variant="outlined"
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <MailOutline />
                                </InputAdornment>
                            )
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && email && password) {
                                e.preventDefault();
                                handleLogin();
                            }
                        }}

                    />

                    <TextField
                        label="Password"
                        type={showPassword ? "text" : "password"}
                        variant="outlined"
                        fullWidth
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LockOutlined />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() => setShowPassword((prev) => !prev)}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && email && password) {
                                e.preventDefault();
                                handleLogin();
                            }
                        }}

                    />

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                        <MuiLink
                            component={Link}
                            to="/forgotpassword"
                            sx={{ color: '#6B7280', fontSize: 13, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                        >

                            Forgot Password?
                        </MuiLink>
                    </Box>

                    {error && (
                        <Typography variant="body2" sx={{ color: 'red', textAlign: 'center' }}>
                            {error}
                        </Typography>
                    )}

                    <Button

                        variant="contained"
                        fullWidth
                        disabled={!email || !password}
                        onClick={handleLogin}
                        sx={{
                            borderRadius: 2,
                            height: 48,
                            background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                            color: '#ffffff',
                            fontSize: 16,
                            fontWeight: 700,
                            textTransform: 'none',
                            boxShadow: '0 8px 20px rgba(34,197,94,0.35)',
                        }}

                    >
                        Continue
                        <ArrowForward sx={{ ml: 1, fontSize: 18 }} />
                    </Button>

                    <Box sx={{ mt: 1, textAlign: 'center' }}>
                        <Typography sx={{ color: '#94A3B8', fontSize: 12 }}>
                            🛡️ Secured by <strong style={{ color: '#64748B' }}>DigiNxtHlt Solutions Pvt Ltd</strong>
                        </Typography>
                    </Box>
                </Box>
            </Paper>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert onClose={handleClose} severity={snackbar.severity} sx={{ width: "100%" }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>

            <Box
                sx={{
                    position: 'absolute',
                    bottom: 12,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    textAlign: 'center',
                    zIndex: 1,
                }}
            >
                <Typography
                    variant="body2"
                    sx={{
                        fontSize: 12,
                        fontWeight: 600,
                        letterSpacing: '0.3px',
                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        display: 'inline-block',
                        lineHeight: 1.4,
                    }}
                >
                    © 2025 DigiNxtHlt Solutions Private Limited. All rights reserved.
                </Typography>
            </Box>

        </Box>
    );
}

export default LoginPage;
